import * as auth from './auth';
import * as firebase from './firebase';

export {
  auth,
  firebase,
};


// WEBPACK FOOTER //
// ./src/firebase/index.js